import { FileModel } from '../file.model';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { RefProperty } from '../ref-property.model';
import { DataEntryPresenterModel } from './data-entry-presenter.model';

export class NotificationPresenterModel extends DataEntryPresenterModel {
  title: LocalizedValueModel;
  content?: LocalizedValueModel;
  readAt?: string;
  icon: IconModel;
  reference: RefProperty;
  module: RefProperty;
  attachment?: FileModel;
}
